/* ATLAS — comportements partagés (un seul fichier pour toutes les sections Atlas) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection;
  var lightData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  var isDesktop = function () { return window.matchMedia('(min-width: 750px)').matches; };

  /* ---------- Révélation au scroll + reflet d'or ---------- */
  document.documentElement.classList.add('js-motion');
  var revealTargets = document.querySelectorAll('.atlas-reveal, .atlas-sheen:not(.atlas-sheen--onload)');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (el) { el.classList.add('is-revealed'); });
  } else {
    var revealer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        revealer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });
    revealTargets.forEach(function (el) { revealer.observe(el); });
  }

  /* ---------- Vidéos ----------
     Hero et bannière vidéo des collections : chargées dès l'ouverture de la page et lancées
     toutes seules (muettes et lues dans la page, ce que les téléphones exigent). Si le téléphone
     refuse quand même (ex. mode économie d'énergie sur iPhone), elles démarrent au premier
     toucher de l'écran. Hors de l'écran, elles se mettent en pause. */
  function sourceFor(video) {
    return isDesktop() ? video.dataset.srcDesktop : (video.dataset.srcMobile || video.dataset.srcDesktop);
  }

  var GESTURES = ['touchstart', 'touchend', 'pointerdown', 'keydown'];

  function setupVideo(video, opts) {
    if (!video || reduceMotion || lightData) return;
    var container = opts.container;
    var userPaused = false;
    var loaded = false;
    // Vidéo du haut de page : considérée visible dès le départ, sans attendre la première mesure
    var visible = !!opts.immediate || !('IntersectionObserver' in window);
    var waitingForGesture = false;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function load() {
      if (loaded) return;
      var src = sourceFor(video);
      if (!src) return;
      loaded = true;
      video.addEventListener('playing', function () {
        container.classList.add('is-playing');
        if (opts.toggle) opts.toggle.hidden = false;
      }, { once: true });
      video.preload = 'auto';
      video.src = src;
    }
    function retryOnGesture() {
      waitingForGesture = false;
      GESTURES.forEach(function (type) { document.removeEventListener(type, retryOnGesture, true); });
      play();
    }
    function play() {
      if (!loaded || userPaused || !visible) return;
      var attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(function () {
          if (waitingForGesture) return;
          waitingForGesture = true;
          GESTURES.forEach(function (type) { document.addEventListener(type, retryOnGesture, { capture: true, passive: true }); });
        });
      }
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) play(); });
    window.addEventListener('pageshow', play);

    if (opts.toggle) {
      opts.toggle.addEventListener('click', function () {
        var paused = !video.paused;
        userPaused = paused;
        if (paused) video.pause(); else video.play().catch(function () {});
        opts.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        opts.toggle.setAttribute('aria-label', paused ? opts.toggle.dataset.labelPlay : opts.toggle.dataset.labelPause);
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) {
          load();
          play();
        } else if (loaded) {
          video.pause();
        }
      }, { threshold: opts.threshold || 0.25, rootMargin: opts.rootMargin || '0px' }).observe(container);
    }

    // Vidéos du haut de page : on commence à charger tout de suite, sans attendre la fin de la page
    if (opts.immediate || visible) {
      load();
      play();
    }
  }

  document.querySelectorAll('[data-atl-hero]').forEach(function (hero) {
    setupVideo(hero.querySelector('.atl-hero__video'), {
      container: hero,
      toggle: hero.querySelector('.atl-hero__toggle'),
      immediate: true,
      threshold: 0.1
    });
  });
  document.querySelectorAll('.atl-uni--sport').forEach(function (tile) {
    setupVideo(tile.querySelector('.atl-uni__video'), { container: tile, threshold: 0.35, rootMargin: '200px 0px' });
  });
  document.querySelectorAll('[data-atl-colvideo]').forEach(function (banner) {
    setupVideo(banner.querySelector('.atl-colhero__video'), {
      container: banner,
      toggle: banner.querySelector('.atl-hero__toggle'),
      immediate: true,
      threshold: 0.1
    });
  });

  /* ---------- Onglets (meilleurs vendeurs) ---------- */
  document.querySelectorAll('[data-atl-tabs]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) { if (on) panel.removeAttribute('data-inactive'); else panel.setAttribute('data-inactive', ''); }
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  });

  /* ---------- Barre livraison gratuite + Black Box ---------- */
  function formatMoney(cents, el) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(el.dataset.locale, { style: 'currency', currency: el.dataset.currency || 'CAD' }).format(amount);
    } catch (err) {
      return amount.toFixed(2) + ' $';
    }
  }
  function renderShipping(el, totalCents) {
    var threshold = Number(el.dataset.threshold) || 0;
    if (!threshold) return;
    var remaining = threshold - totalCents;
    var text = el.querySelector('.atl-ship__text');
    var fill = el.querySelector('.atl-ship__fill');
    if (remaining > 0) {
      text.innerHTML = el.dataset.template.replace('[amount]', formatMoney(remaining, el));
      el.classList.remove('is-unlocked');
    } else {
      text.textContent = el.dataset.unlocked;
      el.classList.add('is-unlocked');
    }
    if (fill) fill.style.transform = 'scaleX(' + Math.min(totalCents / threshold, 1) + ')';
  }
  var shipBars = document.querySelectorAll('[data-atl-ship]');
  /* Dawn déclare PUB_SUB_EVENTS avec « const » : nom global, mais pas une propriété de window */
  if (shipBars.length && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { shipBars.forEach(function (el) { renderShipping(el, cart.total_price); }); })
        .catch(function () {});
    });
  }

  /* ---------- Barre d'achat collante (téléphone) ---------- */
  document.querySelectorAll('[data-atl-sticky]').forEach(function (bar) {
    var sectionId = bar.dataset.sectionId;
    var mainButton = document.querySelector('#product-form-' + sectionId + ' [name="add"]') ||
      document.querySelector('product-info [name="add"], form[action*="/cart/add"] [name="add"]');
    if (!mainButton || !('IntersectionObserver' in window)) return;
    var stickyButton = bar.querySelector('[data-atl-sticky-btn]');
    var stickyPrice = bar.querySelector('[data-atl-sticky-price]');
    var defaultLabel = stickyButton.textContent;
    document.body.appendChild(bar);

    function syncState() {
      var disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      var label = mainButton.querySelector('span');
      stickyButton.textContent = disabled && label ? label.textContent.trim() : defaultLabel;
      var priceRoot = document.getElementById('price-' + sectionId);
      if (priceRoot && stickyPrice) {
        var onSale = priceRoot.querySelector('.price--on-sale');
        var priceEl = onSale ? priceRoot.querySelector('.price-item--sale') : priceRoot.querySelector('.price__regular .price-item--regular');
        if (priceEl && priceEl.textContent.trim()) stickyPrice.textContent = priceEl.textContent.trim();
      }
    }
    new MutationObserver(syncState).observe(mainButton, { attributes: true, childList: true, subtree: true });
    var priceRoot = document.getElementById('price-' + sectionId);
    if (priceRoot) new MutationObserver(syncState).observe(priceRoot, { childList: true, subtree: true, characterData: true });
    syncState();

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.hidden = !scrolledPast;
      document.body.classList.toggle('atl-has-sticky-atc', scrolledPast);
    }).observe(mainButton);

    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) return;
      mainButton.click();
    });
  });

  /* ---------- Politiques : sections, sommaire, progression (le texte n'est jamais modifié) ---------- */
  document.querySelectorAll('[data-atl-policy]').forEach(function (article) {
    var body = article.querySelector('.shopify-policy__body');
    if (!body) return;
    var root = body.querySelector('.rte') || body;
    // Un texte collé depuis un autre outil arrive parfois dans plusieurs <div> imbriqués
    while (root.children.length === 1 && root.firstElementChild.tagName === 'DIV') root = root.firstElementChild;

    var toArray = function (list) { return Array.prototype.slice.call(list); };
    var meaningful = function (nodes) {
      return toArray(nodes).filter(function (n) { return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim()); });
    };
    var isLabel = function (el) {
      var text = el && el.textContent.trim();
      return !!el && /^(STRONG|B)$/.test(el.nodeName) && !!text && text.length <= 120;
    };
    var heading = function (text) {
      var h = document.createElement('h2');
      h.className = 'atl-pol-h';
      h.textContent = text;
      return h;
    };

    // 1. Un long paragraphe coupé par des <br> : chaque ligne entièrement en gras devient un titre
    toArray(root.querySelectorAll(':scope > p')).forEach(function (p) {
      if (!p.querySelector('br')) return;
      var lines = [[]];
      toArray(p.childNodes).forEach(function (n) {
        if (n.nodeName === 'BR') lines.push([]); else lines[lines.length - 1].push(n);
      });
      var isHeadingLine = function (line) { var m = meaningful(line); return m.length === 1 && isLabel(m[0]); };
      if (!lines.some(isHeadingLine)) return;
      var frag = document.createDocumentFragment();
      var para = null;
      lines.forEach(function (line) {
        var m = meaningful(line);
        if (!m.length) { para = null; return; }
        if (isHeadingLine(line)) { frag.appendChild(heading(m[0].textContent.trim())); para = null; return; }
        if (!para) { para = document.createElement('p'); frag.appendChild(para); } else { para.appendChild(document.createElement('br')); }
        line.forEach(function (n) { para.appendChild(n); });
      });
      p.replaceWith(frag);
    });

    // 2. Paragraphes : gras seul = titre, « Label : texte » = encadré, date de mise à jour, vides retirés
    toArray(root.querySelectorAll(':scope > p')).forEach(function (p) {
      var m = meaningful(p.childNodes);
      if (!m.length && !p.querySelector('img')) { p.remove(); return; }
      if (m.length === 1 && isLabel(m[0]) && !m[0].querySelector('a')) { p.replaceWith(heading(m[0].textContent.trim())); return; }
      if (/^(last updated|derni[eè]re mise [aà] jour)/i.test(p.textContent.trim())) { p.classList.add('atl-pol-meta'); return; }
      if (m.length > 1 && isLabel(m[0]) && /:\s*$/.test(m[0].textContent)) p.classList.add('atl-pol-callout');
    });
    toArray(root.querySelectorAll(':scope > h2')).forEach(function (h) { h.classList.add('atl-pol-h'); });
    toArray(root.querySelectorAll(':scope > h3, :scope > h4')).forEach(function (h) { h.classList.add('atl-pol-sub'); });
    toArray(root.querySelectorAll('table')).forEach(function (table) {
      var wrap = document.createElement('div');
      wrap.className = 'atl-pol-table';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });

    // 3. Un titre suivi directement d'un autre titre est le surtitre du document
    var kids = toArray(root.children);
    kids.forEach(function (el, i) {
      if (el.matches('h2.atl-pol-h') && kids[i + 1] && kids[i + 1].matches('h2.atl-pol-h')) {
        var kicker = document.createElement('p');
        kicker.className = 'atl-pol-kicker';
        kicker.textContent = el.textContent;
        el.replaceWith(kicker);
      }
    });

    // 4. Regroupement en sections
    var blocks = [];
    var frag = document.createDocumentFragment();
    var intro = document.createElement('div');
    intro.className = 'atl-pol-intro';
    frag.appendChild(intro);
    var current = intro;
    toArray(root.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.matches('h2.atl-pol-h')) {
        current = document.createElement('section');
        current.className = 'atl-pol-block';
        frag.appendChild(current);
        blocks.push(current);
      }
      current.appendChild(n);
    });
    if (!intro.textContent.trim()) intro.remove();
    root.appendChild(frag);
    root.classList.add('atl-pol-doc');

    // 5. Politiques courtes en cartes ; longues avec sommaire
    var cards = blocks.length >= 3 && blocks.every(function (b) { return b.textContent.trim().length < 480; });
    if (cards) root.classList.add('atl-pol-doc--cards');
    var toc = document.querySelector('[data-atl-policy-toc]');
    var list = toc && toc.querySelector('ol');
    var used = {};
    var slug = function (text) {
      var base = text.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
      var id = 'pol-' + base;
      var n = 2;
      while (used[id] || document.getElementById(id)) id = 'pol-' + base + '-' + n++;
      used[id] = true;
      return id;
    };
    var links = [];
    blocks.forEach(function (block) {
      var h = block.querySelector('.atl-pol-h');
      var text = h.textContent.trim();
      var parts = text.match(/^(section\s+\d+)\s*[-–—:]\s*(.+)$/i);
      if (parts) {
        h.textContent = '';
        var num = document.createElement('span');
        num.className = 'atl-pol-h__num';
        num.textContent = parts[1];
        var label = document.createElement('span');
        label.className = 'atl-pol-h__title';
        label.textContent = parts[2];
        h.appendChild(num);
        h.appendChild(document.createTextNode(' '));
        h.appendChild(label);
      }
      block.id = slug(parts ? parts[2] : text);
      if (!list) return;
      var a = document.createElement('a');
      a.className = 'atl-policy__toc-link';
      a.href = '#' + block.id;
      if (parts) {
        var badge = document.createElement('span');
        badge.className = 'atl-policy__toc-num';
        badge.textContent = parts[1].replace(/\D+/g, '');
        a.appendChild(badge);
      }
      a.appendChild(document.createTextNode(parts ? parts[2] : text));
      var li = document.createElement('li');
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });

    if (toc && blocks.length >= 4 && !cards) {
      toc.hidden = false;
      var wide = window.matchMedia('(min-width: 990px)');
      toc.open = wide.matches;
      links.forEach(function (a) {
        a.addEventListener('click', function () { if (!wide.matches) toc.open = false; });
      });
      if ('IntersectionObserver' in window) {
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            links.forEach(function (a) {
              if (a.getAttribute('href') === '#' + entry.target.id) a.setAttribute('aria-current', 'location');
              else a.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '-25% 0px -65% 0px' });
        blocks.forEach(function (b) { spy.observe(b); });
      }
    }

    // 6. Barre de progression de lecture
    var bar = document.querySelector('[data-atl-policy-progress]');
    if (bar) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var rect = article.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var ratio = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
        bar.style.transform = 'scaleX(' + ratio.toFixed(3) + ')';
      };
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }, { passive: true });
      update();
    }
  });

  /* ---------- Avis ---------- */
  document.querySelectorAll('[data-atl-reviews]').forEach(function (root) {
    var more = root.querySelector('[data-atl-reviews-more]');
    if (more) {
      more.addEventListener('click', function () {
        root.querySelectorAll('[data-extra]').forEach(function (li) { li.hidden = false; });
        more.remove();
      });
    }
    var form = root.querySelector('.atl-review-form');
    var details = root.querySelector('.atl-reviews__write');
    if (form && details && form.querySelector('.atl-review-form__success, .atl-review-form__error')) {
      details.open = true;
      details.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  });
})();
